<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
            @delete-item="deleteType"></view-item>

        <list-items v-else title="Activity Types" @show-item="showItem" ref="table">
            <import-form
            :subject="$translate('activity_types')"
            v-model="importModal"
            @cancel="hideModal()"
            :fields="inventoryFields"
            :upload-record="uploadInventoryRecord"
            :isactivitytype="isactivitytype"
            settings-key-name="ActivityTypeUploadKey"
          ></import-form>
          <div
          class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
      >
          <b-button
          id="add-checkoff-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$addLabel()"
          v-if="hasPermissionCreate"
         @click="item = {}"
          >
          <img src="@/assets/images/icon/gradient-add.svg" />
          </b-button>

          <b-button
          id="import-checkoff-item-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('import')"
          @click="openModel()"
          v-if="hasPermissionCreate"
        >
          <img src="@/assets/images/icon/import.svg" />
        </b-button>
        <b-button
        id="export-checkoff-item-btn"
        variant="blue-icon"
        v-b-tooltip.hover
        :title="$translate('export')"
        @click="export_workflow()"
        v-if="hasPermissionCreate"
      >
        <img src="@/assets/images/icon/export.svg" />
      </b-button>
      </div>
          
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
 
  {
    name: "is_default",
    label: "is_default",
    required: false,
    type: "text",
  },
  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  {
    name: "transaction_type",
    label: "transaction_type",
    required: true,
    type: "text",
  },
  {
    name: "officer",
    label: "officer",
    required: false,
    type: "text",
  },
//   {
//     name: "is_mandatory_value_type_format",
//     label: "is_mandatory_value_type_format",
//     required: false,
//     type: "text",
//     options: [
//       { 'value': 0, 'text': 'No'},
//       { 'value': 1, 'text': 'Yes'},
//     ]
//   },
  {
    name: "interaction_type",
    label: "interaction_type",
    required: false,
    type: "text",
  },
//   {
//     name: "do_release_value_type_format",
//     label: "do_release_value_type_format",
//     required: false,
//     type: "text",
//     options: [
//       { 'value': 0, 'text': 'No'},
//       { 'value': 1, 'text': 'Yes'},
//     ]
//   },
  {
    name: "customer_portal_name",
    label: "customer_portal_name",
    required: false,
    type: "text",
  },
//   {
//     name: "attachment_required_value_type_format",
//     label: "attachment_required_value_type_format",
//     required: false,
//     type: "text",
//     options: [
//       { 'value': 0, 'text': 'No'},
//       { 'value': 1, 'text': 'Yes'},
//     ]
//   },
  {
    name: "reference_prefix",
    label: "reference_prefix",
    required: false,
    type: "text",
  },
  {
    name: "reference_start_number",
    label: "reference_start_number",
    required: false,
    type: "text",
  },
//   {
//     name: "signature_required_value_type_format",
//     label: "signature_required_value_type_format",
//     required: false,
//     type: "text",
//     options: [
//       { 'value': 0, 'text': 'No'},
//       { 'value': 1, 'text': 'Yes'},
//     ]
//   },

  {
    name: "activity_category",
    label: "activity_category",
    required: false,
    type: "text",
  },
  {
    name: "activity_template",
    label: "activity_template",
    required: false,
    type: "text",
  },
//   {
//     name: "ext_acc_bill_generate_value_type_format",
//     label: "ext_acc_bill_generate_value_type_format",
//     required: false,
//     type: "text",
//     options: [
//       { 'value': 0, 'text': 'No'},
//       { 'value': 1, 'text': 'Yes'},
//     ]
//   },
  {
    name: "is_customer_portal_visible",
    label: "is_customer_portal_visible",
    required: false,
    type: "text",
  },
  {
    name: "is_customer_portal_selection",
    label: "is_customer_portal_selection",
    required: false,
    type: "text",
  },
  {
    name: "do_release_before_completed",
    label: "do_release_before_completed",
    required: false,
    type: "text",
  },
  {
    name: "allow_payment",
    label: "allow_payment",
    required: false,
    type: "text",
  },
  {
    name: "rental_allowable",
    label: "rental_allowable",
    required: false,
    type: "text",
  },
  {
    name: "crm_task",
    label: "crm_task",
    required: false,
    type: "text",
  },
  {
    name: "t_and_c",
    label: "t_and_c",
    required: false,
    type: "text",
  },
  {
    name: "reminder_before_days",
    label: "reminder_before_days",
    required: false,
    type: "text",
  },
  {
    name: "reminder_after_days",
    label: "reminder_after_days",
    required: false,
    type: "text",
  },
  {
    name: "default_percent_of_grand_total",
    label: "default_percent_of_grand_total",
    required: false,
    type: "text",
  },
  {
    name: "default_percent_of_rental_item_value",
    label: "default_percent_of_rental_item_value",
    required: false,
    type: "text",
  },
  {
    name: "default_flat_amount",
    label: "default_flat_amount",
    required: false,
    type: "text",
  },
  {
    name: "default_rental_days",
    label: "default_rental_days",
    required: false,
    type: "text",
  },
 

];
export default {
    name: 'activityTypes',
    components: {
        ListItems,
        ViewItem,
        ImportForm
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins,importMixins],
    data() {
        return {
            item: null,
            inventoryFields,
            isactivitytype : 'yes',
            importModal : false,
        }
    },
    computed: {
        componentName(){
            return this.$translate('activity_types')
        },
        items() {
            const items = this.$store.state.orderType.items
            return items
        },
    },
    methods: {
        async doSearch() {
            await this.$store.dispatch('orderType/fetchAll')
        },
        showItem(id) {
            console.log('idssss', id)
            this.item = this.items.find(x => x.id === id)
        },
        resetItems(status) {
            this.genericToast(
                this.componentName,
                status,
                'success',
                `${this.componentName} ${status.toLowerCase()} ${this.$translate('succcessfully')}`
            )
            this.item = null
            this.doSearch()
        },

        async uploadInventoryRecord(
  dataRecord,
  statusRecord,
  { check, message, field },
  statuses,
  setLoading
) {
  try {
    // Destructure the fields from the dataRecord
    let {
      name,
      is_default,
      description,
      transaction_type,
      officer,
      interaction_type,
      customer_portal_name,
      reference_prefix,
      reference_start_number,
      activity_category,
      is_customer_portal_visible,
      is_customer_portal_selection,
      do_release_before_completed,
      allow_payment,
      rental_allowable,
      crm_task,
      t_and_c,
      reminder_before_days,
      reminder_after_days,
      default_percent_of_grand_total,
      default_percent_of_rental_item_value,
      default_flat_amount,
      default_rental_days,
      activity_template
    } = dataRecord;

    // Field mappings (clean up values)
    name = name?.trim() || "";
    is_default = is_default || 0;
    description = description?.trim() || "";
    transaction_type = transaction_type?.trim() || "";
    officer = officer?.trim() || "";
    interaction_type = interaction_type?.trim() || "";
    customer_portal_name = customer_portal_name?.trim() || "";
    reference_prefix = reference_prefix?.trim() || "";
    reference_start_number = reference_start_number?.trim() || "";
    activity_category = activity_category?.trim() || "";
    is_customer_portal_visible = is_customer_portal_visible || 0;
    is_customer_portal_selection = is_customer_portal_selection || 0;
    do_release_before_completed = do_release_before_completed || 0;
    allow_payment = allow_payment || 0;
    rental_allowable = rental_allowable || 0;
    crm_task = crm_task?.trim() || "";
    t_and_c = t_and_c?.trim() || "";
    reminder_before_days = reminder_before_days || 0;
    reminder_after_days = reminder_after_days || 0;
    default_percent_of_grand_total = default_percent_of_grand_total || 0;
    default_percent_of_rental_item_value = default_percent_of_rental_item_value || 0;
    default_flat_amount = default_flat_amount || 0;
    default_rental_days = default_rental_days || 0;
    activity_template = activity_template?.trim() || "";

    // Create parameter object
    const param = {
      name,
      description,
      transaction_type,
      officer,
      interaction_type,
      customer_portal_name,
      reference_prefix,
      reference_start_number,
      activity_category,
      is_customer_portal_visible,
      is_customer_portal_selection,
      do_release_before_completed,
      allow_payment,
      rental_allowable,
      crm_task,
      t_and_c,
      reminder_before_days,
      reminder_after_days,
      default_percent_of_grand_total,
      default_percent_of_rental_item_value,
      default_flat_amount,
      default_rental_days,
      is_default,
      activity_template
    };

    console.log({ param });

    // Dispatch the upload action
    const res = await this.$store.dispatch("orderType/upload", param);
    this.tableLoading = true;
    
    this.tableLoading = false;

    // Set status to complete if the upload was successful
    statusRecord.status = statuses.COMPLETE;
  } catch (err) {
    console.error("err", err);
    statusRecord.error_list = typeof err.message == "string"
      ? [["error", [err.message]]]
      : Object.entries(err.message);
    statusRecord.status = statuses.ERROR;
  } finally {
    await this.$store.dispatch('orderType/fetchAllAfterUpload')
   
    // Final loading state cleanup
    setLoading(false);
  }
}
,
    openModel(){
     
      this.importModal = true;   
     },
     async export_workflow(){
     
            this.tableLoading = true
            await this.$store.dispatch('orderType/ExportExcel')
            this.tableLoading = false
     }
    },
}
</script>
<style></style>
